import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { CreateHelpRequestModel } from '@core/models/request/help.model';
import { ApiService } from '../common/api.service';
import { formatDateToString } from '@core/helper';

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  constructor(private readonly http: ApiService) {
  }

  getAll() {
    return this.http.get(
      API_ENDPOINT.help.controller + API_ENDPOINT.help.getAll,
    );
  }

  getDetail(id: number) {
    return this.http.get(
      API_ENDPOINT.help.controller + API_ENDPOINT.help.getDetail + id,
    );
  }

  create(data: CreateHelpRequestModel) {
    const req = this.prepareCreateHelpRequestModel(data);
    return this.http.post(
      API_ENDPOINT.help.controller,
      req,
    );
  }

  update(data: CreateHelpRequestModel, id: number) {
    const req = this.prepareCreateHelpRequestModel(data);
    return this.http.put(
      API_ENDPOINT.help.controller + id,
      req,
    );
  }

  delete(id: number) {
    return this.http.delete(
      API_ENDPOINT.help.controller + id,
    );
  }

  createDraft(data: CreateHelpRequestModel) {
    const req = this.prepareCreateHelpRequestModel(data);
    return this.http.post(
      API_ENDPOINT.help.controller + API_ENDPOINT.help.createDraft,
      req,
    );
  }

  private prepareCreateHelpRequestModel(data: CreateHelpRequestModel): CreateHelpRequestModel {
    if (data.sdate) {
      data.sdate = formatDateToString(new Date(new Date(data.sdate).setHours(0, 0, 0, 0)));
    }
    if (data.edate) {
      data.edate = formatDateToString(new Date (new Date(data.edate).setHours(23, 59, 59, 99)));
    }
    return data;
  }
}
